@if (showAddFromDocuments) {
  <tiime-split-button>
    <ng-container first-button *ngTemplateOutlet="addButtonTemplate"></ng-container>
    <button
      tiime-button
      raised
      color="primary"
      second-button
      tiimeTooltip
      [tooltipContent]="validateAndNextTooltipTemplate"
      (click)="openAddFilesFromDocumentsDialog()"
    >
      <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-ic-add-1-1"></mat-icon>
    </button>
    <ng-template #validateAndNextTooltipTemplate>Ajouter une pièce jointe depuis les documents</ng-template>
  </tiime-split-button>
} @else {
  <button tiime-button raised color="primary" (click)="fileInput.click()">Ajouter une pièce jointe</button>
}

<input
  hidden
  #fileInput
  id="file"
  type="file"
  [accept]="joinedAcceptedTypes"
  (change)="handleNewFiles(fileInput.files)"
  (cancel)="$event.stopPropagation()"
  (close)="$event.stopPropagation()"
  multiple
/>

<ng-template #addButtonTemplate>
  <button tiime-button raised color="primary" (click)="fileInput.click()">Ajouter une pièce jointe</button>
</ng-template>
